<template>
  <div class="def-go-to-top" :class="{ 'def-go-to-top_active': isActive }" @click="handlerClick">
    <svg>
      <use xlink:href="#svg-arrow-top"></use>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'DefGoToTop',
  props: ['result'],
  data() {
    return {
      isActive: false,
    };
  },
  mounted() {
    // console.log('mounted');
    window.addEventListener('scroll', this.handlerScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handlerScroll);
  },
  methods: {
    handlerScroll() {
      const position = window.scrollY;

      if (position > 50) {
        this.isActive = true;
        // console.log('show');
        // button.addClass('def-goToTop_active');
      } else {
        this.isActive = false;
        // console.log('hide');
        // button.removeClass('def-goToTop_active');
      }
    },
    handlerClick() {
      $('html, body').animate({ scrollTop: 0 }, 600);
    },
  },
};
</script>

<style lang="scss" scoped>
.def-go-to-top {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 51px;
  height: 51px;
  //border: 1px solid rgba(112, 112, 112, .3);
  position: fixed;
  right: 18px;
  bottom: 60px;
  background-color: #fff;
  opacity: 0;
  pointer-events: none;
  transition: 0.3s linear opacity, 0.3s linear background-color;
  z-index: 2;
  border-radius: 50%;
  box-shadow: 0 4px 15px rgba(97, 142, 175, 0.2);
  cursor: pointer;

  svg {
    width: 18px;
    height: 18px;
    stroke: var(--border-colour-primary);
    transition: 0.3s linear stroke;
  }

  &_active {
    opacity: 1;
    pointer-events: auto;
  }

  &:hover {
    background-color: var(--border-colour-primary);
    svg {
      stroke: #fff;
    }
  }
}
</style>
